/**
 * 10-digit US local number for thread id / sending; null if not a valid US mobile length.
 * Strips repeated leading 1 (e.g. Firestore doc id 115083450279 → 5083450279).
 */
export function normalizePhoneToThreadId(phone) {
  let digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return null;
  while (digits.length > 10 && digits.startsWith('1')) {
    digits = digits.slice(1);
  }
  if (digits.length !== 10) return null;
  return digits;
}

export function formatNormalizedUsPhone(digits) {
  const ten = normalizePhoneToThreadId(digits);
  if (!ten) return (digits && String(digits)) || '—';
  return `(${ten.slice(0, 3)}) ${ten.slice(3, 6)}-${ten.slice(6)}`;
}

export function toUsE164FromNormalized10(digits) {
  const ten = normalizePhoneToThreadId(digits);
  if (!ten) return null;
  return `+1${ten}`;
}
